import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';


export const LogContainer = styled.div<{}>`
  border-bottom: 1px solid #cecece;
`;

export const LogHeader = styled.div<{}>`
  display:flex;
  cursor: pointer;
  padding:10px;
  transition: all 0.1s ease-in-out;
  font-size:20px;

  h3{
    font-weight: 500;
  }
  
  span{
    margin-left: auto;
    
  }

  :hover{
    background: #f0f0f0a9;
  }
`;

export const LogContent = styled.div<{open?:boolean, elementHeight?:number}>`
  max-height: ${props => props.open?props.elementHeight+"px":"0"};
  overflow: hidden;
  transition: max-height 0.2s ease-in-out;
`;

export const LogTable = styled.table`
  min-width:500px;
  border-collapse: collapse;
  ${mq(Devices.mobile)} {
    min-width:unset;
  }
`;

export const LogTHead = styled.thead`
    font-size: 14px;

    tr{
      :last-of-type{
        th{
        
          padding: 5px 10px 10px 10px;
        }
      }
    }

    th{
      color:#000 !important;
      font-weight: 500;
      padding: 5px 10px 5px 10px;
    }
`;

export const LogTBody = styled.tbody`
    font-size: 14px;

    tr:nth-of-type(odd){
      background:#f0f0f0a9;
      :last-of-type{
        td{

          padding: 5px 10px 10px 10px;
        }
      }
    }

    td{
      text-align: center;
      color:#686868;
      padding: 5px 10px 5px 10px;
    }
`;